import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import type { IStyler } from '@alfa-bank/site-util-create-widget/src/models';
import React, { useMemo } from 'react';

import { Block as Component } from '../block';
import type { IDeps, IProps, TBlock } from '../models';
import styles from '../styles/mobile.css';
import { paddedTypesMobile } from '../config';

export const BlockMobile = ({
    borderRadius,
    inner,
    notPadded,
    paddedType = 'standard',
    styler,
    ...rest
}: IProps) => {
    const customStyler: IStyler = notPadded ? {} : paddedTypesMobile[paddedType];

    if (typeof borderRadius !== 'undefined' && borderRadius !== false) {
        customStyler.borderRadius = borderRadius === true ? 4 : borderRadius;
    }

    if (inner) {
        customStyler.borderRadius = 4;
        customStyler.paddingLeft = 0;
        customStyler.paddingRight = 0;
        customStyler.paddingTop = 24;
        customStyler.paddingBottom = 24;
    }

    if (typeof styler?.padding === 'number') {
        const { padding } = styler;

        customStyler.paddingTop = padding;
        customStyler.paddingBottom = padding;
        customStyler.paddingLeft = padding;
        customStyler.paddingRight = padding;
    }

    const Comp = useMemo(
        () => createWidget<IDeps, TBlock>({ styles }, { priorityStyler: true })(Component),
        []
    );

    // eslint-disable-next-line react/jsx-props-no-spreading
    return <Comp styler={{ ...customStyler, ...styler }} {...rest} />;
};
